/** @format */

import React from "react";
import JavascriptHandler from "../apis/javascriptHandler";
// import { Slider } from "../components/";
import { PartnerData, GuideData } from "../types";

import main1 from "../assets/guide/1/main-1@2x.png";
import main2 from "../assets/guide/2/main-2@2x.png";
// import main3 from "../assets/guide/3/main-3@2x.png";
import main4 from "../assets/guide/4/main-4@2x.png";
import main5 from "../assets/guide/5/main-5@2x.png";
import main6 from "../assets/guide/6/11OtherBBannerSinhan@2x.png";
import main7 from "../assets/guide/7/main-7@2x.png";
import main8 from "../assets/guide/8/main-8@2x.png";

import content1_1 from "../assets/guide/1/content-1-img-1@2x.png";
import content2_1 from "../assets/guide/2/content-2-img-1@2x.png";
import content2_2 from "../assets/guide/2/content-2-img-2@2x.png";
import content2_3 from "../assets/guide/2/content-2-img-3@2x.png";

import content3_3 from "../assets/guide/3/content-3-img-3@2x.png";

import content4_1 from "../assets/guide/4/content-4-img-1@2x.png";
import content4_2 from "../assets/guide/4/content-4-img-2@4x.gif";
import content4_3 from "../assets/guide/4/content-4-img-3@2x.png";
import content4_4 from "../assets/guide/4/content-4-img-4@2x.png";
import content6_1 from "../assets/guide/6/content-6-img-1@2x.png";
import content6_2 from "../assets/guide/6/12OtherContent6Img2@2x.png";
import content6_4 from "../assets/guide/6/content-6-img-4@2x.png";

import marathonEvent from "../assets/guide/event/11OtherBBannerRun@2x.png";
import marathonEventContent1 from "../assets/guide/event/12OtherContent5Img2@2x.png";
import marathonEventContent2 from "../assets/guide/event/12OtherContent6Img2@2x.png";

import nhLogo from "../assets/logo-nh@2x.png";
import shinhanLogo from "../assets/logo-sinhan@2x.png";
import hyLogo from "../assets/logo-hy@2x.png";
import ibkLogo from "../assets/logo-ibk@2x.png";
import samjanLogo from "../assets/logo-samjan@2x.png";
import kbLogo from "../assets/logo-kb@2x.png";
import kyoboLogo from "../assets/logo-kyobo@2x.png";
import shcLogo from "../assets/logo-sinhanc@2x.png";
import bithumbLogo from "../assets/logo-bit@2x.png";
import javascriptHandler from "../apis/javascriptHandler";

// Slider Images
import img1_1 from "../assets/guide/7/1Img1@2x.png";
import img1_2 from "../assets/guide/7/1Img2@2x.png";
import img1_3 from "../assets/guide/7/1Img3@2x.png";

import img2_1 from "../assets/guide/7/2Img1@2x.png";
import img2_3 from "../assets/guide/7/2Img3@2x.png";

import img3_1 from "../assets/guide/7/3Img1@2x.png";
import img3_2 from "../assets/guide/7/3Img2@2x.png";

import img8_3 from "../assets/guide/8/img3@2x.png";
import img8_4 from "../assets/guide/8/img4@2x.png";
import img8_5 from "../assets/guide/8/img5@2x.png";

import img8_6 from "../assets/guide/8/img6@2x.png";
import img8_7 from "../assets/guide/8/img7@2x.png";
import img8_8 from "../assets/guide/8/img8@2x.png";

export const guideData: Record<number, GuideData> = {
   0: {
      id: 0,
      order: 1,
      title: "인증이 필요할 때, 쯩",
      subTitle: "안전하고 간편한 인증을 쯩 하나로",
      img: main1,
      keyColor: "#99AFFF",
      desc: (
         <>
            <p>
               <span>
                  금융 서비스를 이용할 때 필수인 비대면 실명인증부터 방문인증,
                  자격인증 등 우리는 살면서 인증이 필요한 순간들을 수없이
                  마주하게 됩니다.
                  <br />
                  그때마다 인증 수단을 매번 챙기는 것은 어렵고 불편하지만 소중한
                  나의 개인 정보 인증을 소홀히 할 수는 없어요.
               </span>
            </p>

            <img src={content1_1} alt="나를 증명하는 새로운 방식 쯩" />

            <p>
               <span>이제 “쯩” 하나만 준비하세요.</span>
               <span>
                  인증이 필요할 때 가장 안전하고 간편한 인증 서비스를 이용해
                  보세요.
                  <br />
                  쯩은 내 개인 정보를 블록체인 기술로 암호화하여 안전하게
                  휴대폰에 보관하고 지문 한 번으로 간편하게 제출할 수 있는
                  신원인증 서비스입니다.
               </span>
            </p>

            <div className="divider" />

            <h2>쯩으로 새로워질 일상은 어떤 모습일까요?</h2>

            <p className="pad">
               <span className="list-item">
                  <b>· 금융 서비스에서 비대면 인증할 때</b>
                  <br />
                  <span className="list-desc">
                     매번 신분증을 촬영하고 내 계좌를 찾아 인증할 필요 없이
                     쯩으로 빠르게 인증할 수 있어요.
                  </span>
                  <button
                     onClick={() => {
                        javascriptHandler._callHandler(
                           "OpenWebView",
                           `guide/1`
                        );
                     }}
                     className="white-button"
                  >
                     비대면 계좌 개설할 때, 쯩 바로가기
                  </button>
               </span>
            </p>
            <p>
               <span className="list-item">
                  <b>· 증명서가 필요할 때</b>
                  <br />
                  <span className="list-desc">
                     여기저기서 급하게 찾을 필요 없이 쯩에 증명서를 모아두었다가
                     바로 제출할 수 있어요.
                  </span>
               </span>
               <button
                  onClick={() => {
                     javascriptHandler._callHandler("OpenWebView", `guide/2`);
                  }}
                  className="white-button"
                  style={{ marginBottom: 0 }}
               >
                  내 증명서를 한 번에! 쯩 바로가기
               </button>
            </p>
            <div style={{ height: 6 }}></div>
            <p>
               <span>앞으로 더 다양한 모습으로 찾아갈 쯩을 기대해 주세요.</span>
            </p>
         </>
      ),
   },
   1: {
      id: 1,
      order: 1,
      title: "비대면 계좌 개설할 때, 쯩",
      subTitle: "금융위원회 혁신금융서비스 지정(MyID)",
      img: main6,
      keyColor: "#4C87FF",
      desc: (
         <>
            <h2>실명인증이 뭐예요?</h2>
            <p>
               <span>
                  그동안 금융 앱을 사용할 때마다 꼭 필요했던 실명인증.
                  <br />
                  매번 신분증 촬영하고 1원 송금하느라 귀찮으셨죠?
               </span>
            </p>
            <img src={content6_1} alt="비대면 계좌 개설할 때, 쯩" />
            <p>
               <span>
                  쯩이 NH농협은행과 간편하고 안전한 실명인증 서비스를
                  만들었어요.
                  <br />
                  <br />
                  쯩에서 신분증과 내가 보유한 은행 계좌를 한 번만 인증해두면
                  앞으로 지문 한 번으로 바로 비대면 계좌를 개설할 수 있어요.
               </span>
            </p>
            <h2>언제 쓸 수 있는 건가요?</h2>
            <p>
               <span>
                  실명인증이 필요한 다양한 금융 업무에 사용할 수 있어요.
               </span>
               <div className="example">
                  <span style={{ color: "black" }}>사용예시</span>
                  <span style={{ marginTop: 10 }}>NH 농협은행</span>
                  <ul className="big">
                     <li>올원패스 발급할 때, 송금 한도 변경할 때</li>
                  </ul>
               </div>
            </p>
            <h2>어디에서 사용할 수 있나요?</h2>
            <p>
               <span>
                  현재는 NH농협은행의 올원뱅크 앱에서 사용 가능하지만 앞으로 더
                  다양한 금융기관으로 확장할 예정이에요.
               </span>
            </p>
            <img src={content6_2} alt="비대면 계좌 개설할 때, 쯩" />
         </>
      ),
      footer: (
         <div className="gray">
            <ul>
               <li>
                  쯩 실명인증은 블록체인 신원 증명(DID) 기술을 활용한 새로운
                  개념의 신원인증 서비스입니다.
               </li>
               <li>
                  금융혁신지원 특별법에 따른 혁신금융서비스(MyID)로 선정되어
                  시험 운영하는 서비스로서 관련된 상세한 내용은 쯩 서비스 이용
                  약관 ‘15조 서비스에 대한 위험 고지 및 확인’에서 보실 수
                  있습니다.
               </li>
            </ul>
            <img
               style={{
                  width: 148,
                  padding: 0,
                  marginTop: 12,
                  marginLeft: 13,
                  marginBottom: 10,
               }}
               src={content6_4}
               alt="비대면 계좌 개설할 때, 쯩"
            />
         </div>
      ),
   },
   2: {
      id: 2,
      order: 2,
      title: "내 증명서를 한 번에!",
      subTitle: "증명서에 대해 알아보아요",
      img: main2,
      keyColor: "#C398FF",
      desc: (
         <>
            <h2>이제 쯩으로 한 번에 관리하세요</h2>
            <p>
               필요할 때 찾기 어렵고 매번 새로 발급받아야 하는 증명서, 관리하기
               너무 힘드셨죠?
               <br />
               이제 사용은 간편하고 관리는 안전한 쯩으로 증명서를 관리해 보세요.
            </p>
            <div className="divider"></div>
            <h2>내 증명서를 한 곳에</h2>
            <p>이곳저곳 흩어져 있는 증명서 이제 ‘쯩’에서 한 번에 관리하세요.</p>
            <img src={content2_1} alt="내 증명서를 한 번에!" />
            <h2>버튼 하나로 끝나는 증명서 제출</h2>
            <p>
               더 이상 일일이 찾아다닐 필요 없이 ‘쯩’에서 증명서를 바로
               제출하세요.
            </p>
            <img src={content2_2} alt="내 증명서를 한 번에!" />
            <h2>블록체인에 보관되는 내 증명서</h2>
            <p>
               소중한 내 개인 정보, 걱정하지 마세요. <br />
               해킹이 불가능한 블록체인으로 내 증명서 정보를 안전하게
               보관합니다.
            </p>
            <img src={content2_3} alt="내 증명서를 한 번에!" />
         </>
      ),
      footer: (
         <>
            <div className="gray">
               <ul>
                  <li>현재는 broof 증명서 불러오기 기능만 가능합니다.</li>
               </ul>
            </div>
         </>
      ),
   },
   3: {
      id: 3,
      order: 3,
      title: "쯩 탄생\n비하인드 스토리",
      subTitle: "쯩을 소개합니다",
      img: main4,
      keyColor: "#4773CD",
      desc: (
         <>
            <p>
               <span>
                  여러분 반가워요!
                  <br />
                  저는 쯩 도우미 키오(KIO)입니다.
               </span>
            </p>
            <img src={content4_1} alt="쯩 탄생 비하인드 스토리" />
            <p>
               <span>
                  쯩이 어떻게 탄생했는지 궁금하시죠?
                  <br />
                  이제부터 쯩 탄생 스토리에 대해 알려드릴게요.
               </span>
               <span>
                  쯩은 ‘세상 모든 사람들이 자신의 정보를 누군가에게 맡겨
                  관리하는 것이 아니라, 자기 스스로 자신의 정체성을 증명하고
                  보호할 수 있는 세상’을 꿈꾸는 아이콘루프 사람들에 의해
                  만들어졌습니다.
               </span>
            </p>
            <h2>쯩 이름과 로고 탄생은?</h2>
            <p>
               <span>
                  우리가 신분 확인을 위해서는 주민등록증, 운전면허증, 학생증
                  같은 각종 신분증들을 비롯하여 졸업증명서, 재직증명서, 수료증
                  등… 그 외에도 수많은 증명서들이 필요합니다. <br />
                  우리는 나를 증명하는 하나의 도구이자 문자인 ‘증’들을 모아
                  ‘쯩’이라는 이름을 만들었습니다.
               </span>
               <span>
                  로고는 직관적으로 이해할 수 있도록 브랜드 이름인 ‘쯩’을 그대로
                  시각화하여 디자인하였습니다.
               </span>
            </p>

            <img src={content4_2} alt="쯩 탄생 비하인드 스토리" />
            <p>
               동그라미 모티프는 True/Proof를 의미하며 거기에 ㅇ와 ㅡ가 만나
               나를 상징하는 Face를 의미하는 동시에 우주 행성이 갖는 상징으로
               Future를 의미하기도 합니다.
            </p>

            <img src={content4_3} alt="쯩 탄생 비하인드 스토리" />
            <p>
               나를 증명하는 새로운 방법인 ‘쯩’은 미래의 증명 서비스를
               선도하겠다는 목표와 함께 단순한 서비스 기능만이 아니라 ‘자신의
               정보를 스스로 보호하고 증명하는 MyID 세상’을 만들겠다는 철학과
               의지가 담겨 있습니다.
            </p>

            <h2>당신을 도와주는 친구 ‘키오(KIO)’</h2>
            <p>저에 대해 소개할게요!</p>

            <img src={content4_4} alt="쯩 탄생 비하인드 스토리" />
            <p>
               안녕하세요 :) 저는 쯩의 도우미 ‘키오’입니다. 쯩을 옆으로 돌리면
               영어로 KIO가 되거든요! 여러분을 만나게 되어서 무척 반갑습니다.
               여러분이 앱을 사용하다가 모르는 게 있을 때 언제나 저 키오가 도와
               드릴 거예요. <br />
               다음에 또 만나요~
            </p>
         </>
      ),
   },
   4: {
      id: 4,
      order: 0,
      title: "디지털 마라톤 완주 증명서",
      subTitle: "쯩으로 받을 수 있는",
      img: marathonEvent,
      keyColor: "#4773CD",
      reverseColor: true,
      desc: (
         <>
            <h2>제26회 제주국제관광마라톤축제</h2>
            <p>
               완주하셨다면, 완주 증명서를 나의 휴대폰에 보관해요! <br />
               broof(브루프)에서 블록체인 기반으로 발행된 나의 완주 증명서를
               쯩으로 불러오면 나의 휴대폰에서 간편하게 확인하고 관리할 수
               있어요.
            </p>
            <div className="divider"></div>
            <h2>
               broof에서 발행된 디지털 <br />
               완주 증명서를 쯩으로 받는 법
            </h2>
            <div></div>
            <p>
               <b>1. broof 회원가입하기</b>
               <span className="word-spacing">
                  broof에서 이메일 인증과 휴대폰 본인인증을 완료하시면 가입을
                  완료할 수 있어요.
               </span>
               <div className="example">
                  <ul className="big" style={{ marginTop: 0 }}>
                     <li>
                        마라톤 참여 신청 본인 정보(이름, 휴대폰번호)와 쯩 설치,
                        브루프 가입 본인 정보가 일치해야 합니다.{" "}
                     </li>
                  </ul>
               </div>
            </p>
            <div className="height-40" />
            <p>
               <b>2. 쯩앱으로 돌아와서 broof 연동하기</b>
               <span className="word-spacing">
                  쯩앱의 증명서 탭에서 ‘증명서 불러오기’를 선택하면 발급받은
                  블록체인 증명서를 쯩으로 가져올 수 있어요.{" "}
               </span>
               <img
                  src={marathonEventContent1}
                  alt="디지털 마라톤 완주 증명서"
                  className="padding-0"
               />
               <div className="example" style={{ margin: 0 }}>
                  <ul className="big" style={{ marginTop: 0 }}>
                     <li>broof 서비스의 이용약관 동의가 필요합니다.</li>
                  </ul>
               </div>
            </p>
            <div className="height-40" />
            <p>
               <b>3. 디지털 완주 증명서 확인하기</b>
               <span className="word-spacing">
                  broof에서 불러온 나의 완주 증명서를 확인해 보세요. <br />
                  이제 실물 증명서뿐 아니라 블록체인 증명서로 완주증을 소장해요!
               </span>
               <img
                  src={marathonEventContent2}
                  alt="디지털 마라톤 완주 증명서"
                  className="padding-0"
               />
               <span style={{ marginTop: 20 }}>
                  #제주국제관광마라톤축제 #쯩 #broof #블록체인 완주 증명서
               </span>
               <div style={{ height: 67 }} />
               <button
                  onClick={() => {
                     JavascriptHandler._callHandler(
                        "OpenWebView",
                        "https://www.broof.io/signup"
                     );
                  }}
                  className="blue-button"
               >
                  broof 회원가입하기
               </button>
            </p>
         </>
      ),
   },
};

export const partnerData: PartnerData[] = [
   {
      src: nhLogo,
      name: "농협은행",
   },
   {
      src: shinhanLogo,
      name: "신한은행",
   },
   {
      src: hyLogo,
      name: "한양증권",
   },
   {
      src: shcLogo,
      name: "한양증권",
   },
   {
      src: ibkLogo,
      name: "IBK기업은행",
   },
   {
      src: samjanLogo,
      name: "삼성전자",
   },
   {
      src: kbLogo,
      name: "KB증권",
   },
   {
      src: kyoboLogo,
      name: "교보",
   },
   {
      src: bithumbLogo,
      name: "빗썸",
   },
];

// <iframe
//   src="//www.youtube.com/embed/Yi6g5yCpOeI?autoplay=0&showinfo=0&controls=0"
//   frameBorder="0"
//   allowFullScreen
// />
